<template>
	<!-- ============ HOW DOES IT WORK START ============ -->
		<section id="how">
			<div class="container">
				<div class="row">
					<div class="col-sm-12">
						<h2>COMO TUDO FUNCIONA</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<p>Cansado de participar de processos seletivos e nunca
						receber um retorno sobre as vagas para as quais se candidatou?</p>

						<p>Cada empresa segue seus próprios critérios e formatos, e nem
						sempre fica claro o que realmente importa. Afinal, o que conta
						de verdade na hora da contratação?</p>

						<p>E se as informações do seu currículo virassem dados objetivos,
						organizados para facilitar a sua contratação?</p>

						<p>Você só precisa preencher os campos com as informações mais
						relevantes da sua carreira — o sistema cuida do resto.</p>

						<p>Sem se preocupar com o layout do currículo ou se a formatação
						vai agradar o recrutador da vez.</p>

						<p>Nosso objetivo é simplificar e trazer tecnologia para um
						processo de recrutamento e seleção que, há tempos, ficou engessado.</p>
						<p><a href="#/sobre_nos" class="btn btn-primary">Leia Mais</a></p>
					</div>
					<div class="col-sm-6">
						<div class="video-wrapper">
							<iframe width="560" height="315"
							src="https://www.youtube.com/embed/VqHbQ-WwMfk" frameborder="0"
							allowfullscreen="true"></iframe>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- ============ HOW DOES IT WORK END ============ -->
</template>

<script>
export default {

}
</script>

<style>

</style>